module.exports = __webpack_public_path__ + "img/close.4f5b4bda.svg";